define('models/Conversation',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel'
], function (
    ko,
    _,
    ObservableModel
) {
    'use strict';

    var Conversation = ObservableModel.extend({}, function () {
        var self = this;

        self.divisionIds = ko.computed(function() {
            if (self.divisions && self.divisions()) {
                return _.map(self.divisions(), 'division.id');
            } else {
                return undefined;
            }
        });
    });

    return Conversation;
});

